import FormGroup from "legacy/FormGroup"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: $ is loaded globally

class EditCreditCardForm extends React.Component {
  constructor(args) {
    super(args)

    this.state = {
      showModal: false,
      expirationMonth: this.props.expirationMonth.toLocaleString(undefined, {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }),
      expirationYear: this.props.expirationYear,
      zip: this.props.zip,
    }

    this.save = this.save.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validator = validatorFactory()
  }

  save() {
    this.props.saving(true)
    if (this.validator.allValid()) {
      const params = {
        exp_month: this.state.expirationMonth,
        exp_year: this.state.expirationYear,
        zip: this.state.zip,
        "card-id": this.props.cardId,
        id: this.props.cardId,
      }
      $.ajax({
        type: "PATCH",
        url: this.props.endpoint,
        data: params,
        success: (response) => {
          if (this.props.successCallback) {
            this.props.successCallback(response)
          } else {
            window.location.reload()
          }
        },
        error: (xhr, status, error) => {
          this.props.saving(false)
          this.setState({
            errorMessage: error.toString(),
          })
        },
      })
    } else {
      this.props.saving(false)
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value,
    })
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <FormGroup
              inputType="select"
              label="Expiration Month"
              name="expirationMonth"
              value={this.state.expirationMonth}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "expirationMonth",
                this.state.expirationMonth,
                "required"
              )}
            >
              <option value="" hidden>
                Month
              </option>
              <option value="01">01 - January</option>
              <option value="02">02 - February</option>
              <option value="03">03 - March</option>
              <option value="04">04 - April</option>
              <option value="05">05 - May</option>
              <option value="06">06 - June</option>
              <option value="07">07 - July</option>
              <option value="08">08 - August</option>
              <option value="09">09 - September</option>
              <option value="10">10 - October</option>
              <option value="11">11 - November</option>
              <option value="12">12 - December</option>
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup
              inputType="select"
              label="Expiration Year"
              name="expirationYear"
              value={this.state.expirationYear}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "expirationYear",
                this.state.expirationYear,
                "required"
              )}
            >
              <option value="" hidden>
                Year
              </option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
              <option value="2031">2031</option>
              <option value="2032">2032</option>
              <option value="2033">2033</option>
              <option value="2034">2034</option>
              <option value="2035">2035</option>
              <option value="2036">2036</option>
              <option value="2037">2037</option>
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup
              inputType="input"
              label="Card Billing Zip Code"
              name="zip"
              value={this.state.zip}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "zipcode",
                this.state.zip,
                "required"
              )}
            />
          </div>
        </div>
        {this.state.errorMessage && (
          <div className="alert alert-danger">{this.state.errorMessage}</div>
        )}
      </div>
    )
  }
}

EditCreditCardForm.propTypes = {
  expirationMonth: PropTypes.number,
  expirationYear: PropTypes.number,
  zip: PropTypes.string,
  cardId: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  saving: PropTypes.func.isRequired,
  successCallback: PropTypes.func,
}

export default EditCreditCardForm
